export default defineNuxtPlugin(async () => {
  if (!import.meta.client) return

  const { account, setAccount } = useAuth()

  if (!account.value) await setAccount()
})
